/* eslint-disable no-unused-vars */
import React from "react";
import { FormattedMessage } from "react-intl";
import farm from "../../../app/assets/icons/fazendinha.svg";
import dashboard from "../../../app/assets/icons/dashboard.svg";
import usersProfile from "../../../app/assets/custom-icons/users-icon.svg";
import document from "../../../app/assets/custom-icons/document-search.svg";
import cash from "../../../app/assets/custom-icons/cash.svg";
import tractor from "../../../app/assets/icons/trator.svg";
import clients from "../../../app/assets/icons/clientes.svg";
import iconPlusGreen from "../../../app/assets/icons/icon-plus-green.svg";
import lawsuit from "../../../app/assets/icons/lawsuit.svg";

import adjustments from "../../../app/assets/icons/adjustments.svg";
export default class MenuItemText extends React.Component {
  render() {
    const icons = {
      farm: farm,
      dashboard: dashboard,
      "users-submenu": usersProfile,
      "users-profile": usersProfile,
      "icon-plus-green": iconPlusGreen,
      "usuarios-perfis": usersProfile,
      tractor: tractor,
      clients: clients,
      lawsuit: lawsuit,
      document:document,
      cash: cash,
      adjustments: adjustments,
    };
    const { item, parentItem } = this.props;

    return (
      <>
        {item.icon && (
          <div className="kt-menu__link-icon">
            <img src={icons[item.icon]} className="imagem-menu" alt="" />
          </div>
        )}

        {item.translate ? (
          <span className="kt-menu__link-text" style={{ whiteSpace: "nowrap",
            marginRight: "30px",
            backgroundColor: "red"
          }}>
            <FormattedMessage id={item.translate} defaultMessage={item.title} />
          </span>
        ) : (
          <span
            className="kt-menu__link-text"
            style={{ whiteSpace: "nowrap" }}
            dangerouslySetInnerHTML={{ __html: item.title }}
          />
        )}

        {item.badge && (
          <span className="kt-menu__link-badge">
            <span className={`kt-badge ${item.badge.type}`}>
              {item.badge.value}
            </span>
          </span>
        )}

        {/*{item.submenu && <i className="kt-menu__ver-arrow la la-angle-right" />}*/}
      </>
    );
  }
}
